import React from "react";
import { BriefClientInfo } from "@growth-machine-llc/stridist-api-client";

export const ClientContext = React.createContext<any>(null);

export function useClient(): BriefClientInfo {
  return React.useContext<BriefClientInfo>(ClientContext);
}
